import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmLabelComponent } from './sm-label.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [SmLabelComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule, 
  ],
  exports:[SmLabelComponent]
})
export class SmLabelModule { }
